import React, { Fragment } from "react";
import {
  Dialog as MUIDialog,
  DialogContent,
  DialogContentText,
  Typography,
  DialogTitle,
} from "@mui/material";

import {
  ActiveTextEighteen,
  TextFourteenBlack,
} from "../../../css components/Style";
import { titleCase } from "change-case-all";

export default function MissedParameters({
  formikProps,
  dialogState,
  setDialogState,
}) {
  const handleClose = () => {
    setDialogState({ ...dialogState, state: false });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "0px" }}>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <Typography variant="h6">Missing Parameters</Typography>
          </div>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <TextFourteenBlack variant="">
              Below is the current status of the requested attributes. The
              mandatory attributes have to be accepted before you can proceed.
            </TextFourteenBlack>

            <ActiveTextEighteen>
              {formikProps.values.missedParameter?.map((val, index) =>
                Object.keys(val).map((key) => (
                  <Fragment>
                    <Typography key={index} style={{ margin: "10px 0" }}>
                      {key && titleCase(key?.replace(/_/g, " "))}
                    </Typography>
                    <div style={{ marginLeft: "25px" }}>
                      {val?.[key]?.map((v) => (
                        <Typography>- {v}</Typography>
                      ))}
                    </div>
                  </Fragment>
                ))
              )}
            </ActiveTextEighteen>
          </DialogContentText>
        </DialogContent>
      </MUIDialog>
    </React.Fragment>
  );
}
